import { getMediaAttachmentFileKind, MediaAttachmentFileKind } from '$/utils/mediaUtil';

export const MAX_IMAGE_WIDTH = 112;
export const MAX_IMAGE_HEIGHT = 152;
export const CONTAINER_PADDING = 4;

/**
 * 根据原始宽高与最大宽高限制，计算实际展示宽高（与 MarkPopoverContent 规则一致）
 * ratio > 1：固定宽度 MAX_IMAGE_WIDTH，高度按比例；否则固定高度 MAX_IMAGE_HEIGHT，宽度按比例
 */
export function calcInlineMediaDisplaySize(
  width: number,
  height: number,
): { width: number; height: number; } {
  const ratio = width / height;
  if (ratio > 1) {
    return {
      width: MAX_IMAGE_WIDTH,
      height: MAX_IMAGE_WIDTH / ratio,
    };
  }
  return {
    width: MAX_IMAGE_HEIGHT * ratio,
    height: MAX_IMAGE_HEIGHT,
  };
}

/** 内联附件角标：IconFont 名 + 底色（图标使用白色以保证对比度） */
export type InlineFileIconConfig = {
  icon: string;
  background: string;
  iconColor: string;
};

export const FILE_ICON_MAP = {
  audio: {
    icon: 'musicV3Bold',
    background: 'var(--workspace-attachment-backgroundAudio, #8B7CF6)',
    iconColor: 'var(--workspace-attachment-contentIconFill, #F8F9FA)',
  },
  word: {
    icon: 'fileTextBold',
    background: 'var(--workspace-attachment-backgroundWord, #60A5FA)',
    iconColor: 'var(--workspace-attachment-contentIconFill, #F8F9FA)',
  },
  ppt: {
    icon: 'chartBold',
    background: 'var(--workspace-attachment-backgroundPowerPoint, #F59E66)',
    iconColor: 'var(--workspace-attachment-contentIconFill, #F8F9FA)',
  },
  excel: {
    icon: 'tableBold',
    background: 'var(--workspace-attachment-backgroundExcel, #61CCA2)',
    iconColor: 'var(--workspace-attachment-contentIconFill, #F8F9FA)',
  },
  pdf: {
    icon: 'filePdfBold',
    background: 'var(--workspace-attachment-backgroundPdf, #F87171)',
    iconColor: 'var(--workspace-attachment-contentIconFill, #F8F9FA)',
  },
  markdown: {
    icon: 'fileBold',
    background: 'var(--workspace-attachment-backgroundMarkdown, #94A3B8)',
    iconColor: 'var(--workspace-attachment-contentIconFill, #F8F9FA)',
  },
  html: {
    icon: 'codeBracketsBold',
    background: 'var(--workspace-attachment-backgroundMarkdown, #94A3B8)',
    iconColor: 'var(--workspace-attachment-contentIconFill, #F8F9FA)',
  },
} as const satisfies Record<MediaAttachmentFileKind, InlineFileIconConfig>;

const DEFAULT_INLINE_FILE_ICON: InlineFileIconConfig = {
  icon: 'fileBold',
  background: 'var(--workspace-attachment-backgroundMarkdown, #94A3B8)',
  iconColor: 'var(--workspace-attachment-contentIconFill, #F8F9FA)',
};

/**
 * 根据附件 URL 解析内联盒图标与底色，分类规则与 {@link getMediaAttachmentFileKind} 一致。
 */
export function getInlineFileIconConfig(url: string): InlineFileIconConfig {
  const kind = getMediaAttachmentFileKind(url);
  if (kind) {
    return { ...FILE_ICON_MAP[kind] };
  }
  return DEFAULT_INLINE_FILE_ICON;
}
